import React from 'react';
import PropTypes from 'prop-types';
// Styles
import './styles.scss';

const CardRow = (props) => {
  let inCards;
  if (props.cardNumber === 1) {
    inCards = (
      <article key={1} className="row expanded card-row">
        <div className="large-12 columns card-item">
          {props.cards}
        </div>
      </article>
    );
  } else {
    inCards = props.cards ? (
      <article className="row expanded card-row">
        {
          props.cards.map((card, index) => {
            const key = index + 1;
            return (
              <div key={key} className="large-6 columns card-item">
                {card}
              </div>
            );
          })
        }
      </article>
    ) : [];
  }
  return (inCards);
};

CardRow.propTypes = {
  cardNumber: PropTypes.number,
  cards: PropTypes.array.isRequired
};

CardRow.defaultProps = {
  cardNumber: 2
};

export default CardRow;
